"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const classNames = require("classnames");
exports.Spinner = (_a) => {
    var { children, className } = _a, otherProps = __rest(_a, ["children", "className"]);
    return (React.createElement("div", Object.assign({ className: classNames('spinner', className) }, otherProps), "loading"));
};
exports.Spinner.displayName = 'Spinner';



//////////////////
// WEBPACK FOOTER
// ./src/components/Spinner.tsx
// module id = 122
// module chunks = 0